import app from 'flarum/forum/app';
import { loadOverview, clearOverview } from '../../common/overview';

/**
 * "Your community" in the right sidebar, above Most Read: your states, the Naira rate
 * (abroad) and members. Rendered as plain markup into the theme's sidebar (outside the
 * normal redraw), so the data is loaded first and then drawn once.
 */
export function clearSideCache() {
  clearOverview();
}
export function fillSide(el) {
  const token = el._vouchaSide = (el._vouchaSide || 0) + 1;
  loadOverview().then(d => {
    if (!el.isConnected || el._vouchaSide !== token) return;
    m.render(el, d && d.state === 'ok' ? sideView(d) : null);
  }).catch(() => {});
}
function sideView(d) {
  const link = href => ({
    href,
    onclick: e => {
      if (e.ctrlKey || e.metaKey) return;
      e.preventDefault();
      m.route.set(href);
    }
  });
  return m("div", {
    className: "VouchaSide"
  }, d.leaders && d.leaders.length ? m("div", {
    className: "VouchaSide-leaders"
  }, m("div", {
    className: "VouchaSide-title"
  }, "Community leadership"), d.leaders.map(l => {
    const where = l.role === 'LGA chairperson' ? l.lga : l.state;
    const label = l.role === 'FCT Minister' ? 'FCT Minister' : l.role + ' · ' + where;
    return m("div", {
      className: "VouchaSide-leader"
    }, m("small", null, label), l.name ? l.role === 'LGA chairperson' ? m("strong", null, l.name) : m("a", link(app.route('voucha-community.governors', {
      state: l.stateSlug
    })), m("strong", null, l.name)) : m("span", {
      className: "VouchaSide-missing"
    }, "Not yet recorded"));
  }), m("a", Object.assign({
    className: "VouchaSide-more"
  }, link(app.route('voucha-community.governors'))), "All governors \u2192")) : null, d.members && d.members.length ? m("div", {
    className: "VouchaSide-title"
  }, "Your community") : null, d.members.map(g => m("div", {
    className: "VouchaSide-group"
  }, m("a", Object.assign({
    className: "VouchaSide-groupHead"
  }, link(app.route('voucha-community.members', {
    group: g.key
  }))), m("span", null, g.label), m("span", null, g.count, " ", m("i", {
    className: "fas fa-chevron-right"
  }))), m("div", {
    className: "VouchaSide-avatars"
  }, g.people.map(p => m("a", Object.assign({
    className: "VouchaSide-avatar",
    title: p.displayName
  }, link(app.route('user', {
    username: p.username
  }))), p.avatarUrl ? m("img", {
    src: p.avatarUrl,
    alt: "",
    loading: "lazy",
    onerror: e => {
      const s = document.createElement('span');
      s.textContent = (p.displayName || '?').charAt(0).toUpperCase();
      e.target.replaceWith(s);
    }
  }) : m("span", null, (p.displayName || '?').charAt(0).toUpperCase())))))));
}
flarum.reg.add('voucha-community', 'forum/components/CommunitySide', { clearSideCache: clearSideCache,fillSide: fillSide, });